/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { JOB_TYPE_MANIFEST } from '../JobType/JobType.types';

export type EntityJobManifest = io.TypeOf<typeof JobManifest>;

export const JobManifest = io.type({
  concurrency: io.number,
  entryFile: io.string,
  entryFunction: io.type({
    entry: io.string,
    input: io.type({
      properties: io.record(io.string, io.any),
      required: io.array(io.string),
      type: io.string,
    }),
    name: io.string,
  }),
  name: io.string,
  timeoutSeconds: io.number,
  type: io.literal(JOB_TYPE_MANIFEST),
  version: io.string,
});
